import type { Room } from './rooms';
import { activityDefinitions, type ActivityType, type ActivityUnit } from './activities';

export const RECENT_WORKOUT_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

export interface WorkoutActivityTotal {
  type: ActivityType;
  qty: number;
  unit: ActivityUnit;
}

export interface UserWorkoutPerformance {
  points: number;
  totalReps: number;
  totalSeconds: number;
  activityTotals: WorkoutActivityTotal[];
}

export function getWorkoutsNewestFirst(rooms: readonly Room[]): Room[] {
  return [...rooms].sort((left, right) => right.createdAt - left.createdAt);
}

export function getRecentWorkouts(
  rooms: readonly Room[],
  now = Date.now(),
): Room[] {
  const cutoff = now - RECENT_WORKOUT_WINDOW_MS;
  return getWorkoutsNewestFirst(rooms.filter((room) => room.createdAt >= cutoff));
}

export function getUserWorkoutPerformance(
  room: Room,
  userId: string,
): UserWorkoutPerformance {
  const activityTotals = new Map<ActivityType, number>();
  let totalReps = 0;
  let totalSeconds = 0;

  room.activities.forEach((activity) => {
    if (activity.userId !== userId) return;
    if (activityDefinitions[activity.type].unit === 'seconds') totalSeconds += activity.qty;
    else totalReps += activity.qty;
    activityTotals.set(
      activity.type,
      (activityTotals.get(activity.type) ?? 0) + activity.qty,
    );
  });

  return {
    points: room.participantPoints[userId] ?? 0,
    totalReps,
    totalSeconds,
    activityTotals: Array.from(activityTotals, ([type, qty]) => ({ type, qty, unit: activityDefinitions[type].unit }))
      .sort((left, right) => left.type.localeCompare(right.type)),
  };
}
